import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { Customer } from "../../models";
import { RQ } from "../../globals/enums";
import { add } from "../../api/generic-api";

export const useAddCustomer = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(
    (customer: Partial<Customer>) => add<Customer>(`customers`, customer),
    {
      onSuccess: (customer) => {
        enqueueSnackbar("Customer Added", { variant: "success" });
        queryClient.setQueryData<Customer[]>(
          RQ.CUSTOMERS,
          (customers: Customer[] | undefined) => {
            return [...(customers ?? []), customer];
          }
        );
      },
      onError: () => {
        enqueueSnackbar("Customer Adding Error", { variant: "error" });
      },
    }
  );
};
